export const voiceAgentService = {
  async makeOutboundCall(phoneNumber, useCaseId = "customer-support") {
    try {
      const vapiServerCall = async () => {
        const assistantIds = {
          "sales-assistant": process.env.REACT_APP_VAPI_SALES_ASSISTANT_ID,
          "customer-support": process.env.REACT_APP_VAPI_CUSTOMER_SUPPORT_ASSISTANT_ID,
          "technical-support": process.env.REACT_APP_VAPI_TECHNICAL_SUPPORT_ASSISTANT_ID,
          "appointment-booking": process.env.REACT_APP_VAPI_APPOINTMENT_BOOKING_ASSISTANT_ID,
          "noise": process.env.REACT_APP_VAPI_NOISE_ASSISTANT_ID,
        };

        const assistantId = assistantIds[useCaseId] || process.env.REACT_APP_VAPI_ASSISTANT_ID;

        const response = await fetch("https://api.vapi.ai/call", {
          method: "POST",
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_VAPI_API_KEY}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            phoneNumberId: process.env.REACT_APP_VAPI_PHONE_NUMBER_ID,
            customer: {
              number: phoneNumber,
            },
            assistantId: assistantId,
            assistantOverrides: {
              variableValues: {
                customer_details: "",
                use_case: useCaseId,
                greeting: this.getGreetingForUseCase(useCaseId),
              },
            },
          }),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        return response.json();
      };

      const data = await vapiServerCall();
      return { status: "started", call: data };
    } catch (error) {
      console.error("Error making outbound call:", error);
      throw error;
    }
  },

  getGreetingForUseCase(useCaseId) {
    const greetings = {
      "sales-assistant": "Hi! I'm calling for a cart recovery demonstration. I can help you complete your purchase and find the perfect solution for your needs.",
      "customer-support": "Hello! I'm calling for a customer support demonstration. How can I help you today?",
      "technical-support": "Hello! I'm calling for a technical support demonstration. I can help troubleshoot any technical issues you might have.",
      "appointment-booking": "Hello! I'm calling for an appointment booking demonstration. I can help you schedule appointments efficiently.",
      "noise": "Hello! I'm calling for a noise reduction demonstration. I can help you with audio quality improvements.",
    };
    return greetings[useCaseId] || greetings["customer-support"];
  },
};